module.exports = __webpack_public_path__ + "img/detailmanage.51771a06.png";